import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DenverIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 3.36919C6 0.915201 8.06282 0.5 8.06282 0.5H10.949V0.660215C10.949 0.660215 8.47451 0.82043 8.44479 4.00992L8.44479 18.487V18.5H6L6.00112 18.4872H6L6 3.36919Z",
                fill: "#0086C0",
                stroke: "#0086C0",
                strokeWidth: "0.212476",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.1263 1.14087C11.1263 1.14087 9.06348 1.55607 9.06348 4.01006V18.5001H13.0715C13.0715 18.5001 13.0715 4.63624 13.0715 4.01006C13.0715 3.38388 12.6587 2.42602 11.1263 2.42602V1.14087Z",
                fill: "#0086C0",
                stroke: "#0086C0",
                strokeWidth: "0.212476",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.2354 3.67651V17.8194",
                stroke: "white",
                strokeWidth: "0.39706",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.8232 3.67651V17.8194",
                stroke: "white",
                strokeWidth: "0.39706",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.61865 5.47656H7.85591",
                stroke: "white",
                strokeWidth: "0.529413",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.61865 7.66382H7.85591",
                stroke: "white",
                strokeWidth: "0.529413",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.61865 9.85132H7.85591",
                stroke: "white",
                strokeWidth: "0.529413",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.61865 12.0391H7.85591",
                stroke: "white",
                strokeWidth: "0.529413",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.61865 14.2268H7.85591",
                stroke: "white",
                strokeWidth: "0.529413",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.61865 16.4146H7.85591",
                stroke: "white",
                strokeWidth: "0.529413",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            })
        ]
    });
